import { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { useAuth } from "./useAuth";
import { db } from "../firebase";

export function useFavoris() {
  const { user } = useAuth();
  const [favorisSlugs, setFavorisSlugs] = useState([]);

  useEffect(() => {
    const fetchFavoris = async () => {
      if (!user) return;

      try {
        const q = query(collection(db, "favoris"), where("userId", "==", user.uid));
        const snapshot = await getDocs(q);
        const slugs = snapshot.docs.map((doc) => doc.data().vehicleId); // ← slug stocké
        setFavorisSlugs(slugs);
      } catch (error) {
        console.error("Erreur chargement favoris", error);
      }
    };

    fetchFavoris();
  }, [user]);

  return favorisSlugs;
}
